<template>
      <div class="formIndex">
        <div class="userName">
            <span>姓名</span>
            <el-input placeholder="请输入您的真实姓名"
                      v-model="userName"
                      clearable
                      @focus="userNameFocus"
                      style="width: 70%;margin-right: 10px">
            </el-input>
          </div>
        <div class="idCardType">
          <span style="flex:4">证件类型</span>
          <div class="idCardTypeRadio">
            <el-radio v-model="idCardTypeRadio" @change="idCardTypeChange(idCardTypeRadio)" label="居民身份证">居民身份证</el-radio>
            <el-radio v-model="idCardTypeRadio" @change="idCardTypeChange(idCardTypeRadio)" label="其他">其他</el-radio>
          </div>
        </div>
        <div class="idCardType" v-if="idCardTypeRadio === '其他'">
          <van-field label="证件类型"
                     :value="idCardType"
                     readonly is-link
                     @click="showIdCardTypeSelector"/>
          <van-popup v-model="isShowIdCardTypeSelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="证件类型"
              show-toolbar
              :columns="idCardTypeOptions"
              @confirm="onConfirmIdCardType"
              @cancel="onCancelIdCardType"
            />
          </van-popup>

<!--          <span>证件类型</span>-->
<!--            <el-select v-model="idCardType"-->
<!--                       @focus="hideKey"-->
<!--                       style="width: 70%;margin-right: 10px">-->
<!--              <el-option-->
<!--                v-for="(item,index) in idCardTypeOptions"-->
<!--                :key="index"-->
<!--                :label="item"-->
<!--                :value="item">-->
<!--              </el-option>-->
<!--            </el-select>-->
          </div>
        <div class="idCard">
            <span>证件号码</span>
            <el-input placeholder="请输入正确的证件号码"
                      v-model="idCard"
                      clearable
                      @input="idCardChange"
                      @change="idCardChangeValue"
                      style="width: 70%;margin-right: 10px">
            </el-input>
          </div>
<!--        <div class="idCard" v-if="idCardType === '居民身份证'">-->
<!--          <span>证件号码</span>-->
<!--          <div @click="showKey"-->
<!--               style="width: 65%;margin-right: 12px;font-size: 1.1rem;line-height: 40px">-->
<!--            {{idCard}}<small v-if="idCard === ''" style="color: #cccccc;font-size: 14px">请输入正确的证件号码</small>-->
<!--          </div>-->

<!--        </div>-->
        <div class="sex" v-if="idCardTypeRadio === '其他'">
          <span style="flex:4">性别</span>
          <div class="sexRadio" @click="hideKey">
            <el-radio v-model="sexRadio" label="男" >男</el-radio>
            <el-radio v-model="sexRadio" label="女" >女</el-radio>
          </div>
        </div>
        <div class="age" v-if="idCardTypeRadio === '其他'">
            <span>年龄</span>
            <el-input placeholder="请输入您的真实年龄"
                      v-model="age"
                      clearable
                      @focus="hideKey"
                      style="width: 70%;margin-right: 10px">
            </el-input>
          </div>
        <div class="phone">
            <span>手机号</span>
            <el-input placeholder="请输入您的真实联系方式"
                      v-model="phone"
                      clearable
                      @focus="hideKey"
                      style="width: 70%;margin-right: 10px">
            </el-input>
          </div>

        <div class="gap"></div>

        <div class="department">
          <span style="width: 120px">监狱管理部门</span>
          <el-input placeholder="请输入监狱管理部门"
                    v-model="department"
                    @focus="hideKey"
                    clearable
                    style="width: 70%;margin-right: 10px">
          </el-input>
        </div>
        <div class="EnterpriseName">
          <van-field label="企业名称"
                     :value="EnterpriseName"
                     readonly is-link
                     @click="showEnterpriseNameSelector"/>
          <van-popup v-model="isShowEnterpriseNameSelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="企业名称"
              show-toolbar
              :columns="EnterpriseNameOptions"
              @confirm="onConfirmEnterpriseName"
              @cancel="onCancelEnterpriseName"
            />
          </van-popup>

<!--          <span>企业名称</span>-->
<!--          <el-select v-model="EnterpriseName"-->
<!--                     @focus="hideKey"-->
<!--                     style="width: 70%;margin-right: 10px">-->
<!--            <el-option-->
<!--              v-for="(item,index) in EnterpriseNameOptions"-->
<!--              :key="index"-->
<!--              :label="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </div>
        <div class="EnterpriseName" v-if="EnterpriseName === '其它'">
          <span>企业名称</span>
          <el-input v-model="otherEnterpriseName"
                    @focus="hideKey"
                    placeholder="请额外手动输入企业名称"
                    @change="EnterpriseNameChange(otherEnterpriseName)"
                    style="width: 70%;margin-right: 10px;">
          </el-input>

        </div>
        <div class="personType">
          <van-field label="人员类型"
                     :value="personType"
                     readonly is-link
                     @click="showPersonTypeSelector"/>
          <van-popup v-model="isShowPersonTypeSelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="人员类型"
              show-toolbar
              :columns="personTypeOptions"
              @confirm="onConfirmPersonType"
              @cancel="onCancelPersonType"
            />
          </van-popup>

          <!--          <span>人员类型</span>-->
<!--          <el-select v-model="personType"-->
<!--                     @focus="hideKey"-->
<!--                     style="width: 70%;margin-right: 10px">-->
<!--            <el-option-->
<!--              v-for="(item,index) in personTypeOptions"-->
<!--              :key="index"-->
<!--              :label="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </div>

        <div class="gap"></div>

        <div class="country" v-if="idCardTypeRadio === '其他'">
          <van-field label="国籍"
                     :value="country"
                     readonly is-link
                     @click="showCountrySelector"/>
          <van-popup v-model="isShowCountrySelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="国籍"
              show-toolbar
              :columns="countryOptions"
              @confirm="onConfirmCountry"
              @cancel="onCancelCountry"
            />
          </van-popup>

          <!--          <span>国籍</span>-->
<!--          <el-select v-model="country" placeholder="请选择国籍"-->
<!--                     @focus="hideKey"-->
<!--                     style="width: 70%;margin-right: 10px">-->
<!--            <el-option-->
<!--              v-for="(item,index) in countryOptions"-->
<!--              :key="index"-->
<!--              :label="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </div>
        <div class="Residence">
          <span>居住地</span>
          <el-input placeholder="请输入居住地点"
                    v-model="Residence"
                    @focus="hideKey"
                    clearable
                    style="width: 70%;margin-right: 10px">
          </el-input>
        </div>
        <div class="personIdentity">
          <van-field label="人员身份"
                     :value="personIdentity"
                     readonly is-link
                     @click="showPersonIdentitySelector"/>
          <van-popup v-model="isShowPersonIdentitySelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="人员身份"
              show-toolbar
              :columns="personIdentityOptions"
              @confirm="onConfirmPersonIdentity"
              @cancel="onCancelPersonIdentity"
            />
          </van-popup>

<!--                    <span>人员身份</span>-->
<!--          <el-select v-model="personIdentity"-->
<!--                     @focus="hideKey"-->
<!--                     style="width: 70%;margin-right: 10px"-->
<!--                      @change="personIdentityChange">-->
<!--            <el-option-->
<!--              v-for="(item,index) in personIdentityOptions"-->
<!--              :key="index"-->
<!--              :label="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </div>
        <div class="overSeas" @click="hideKey">
          <span style="flex:4">14天内境外入境人员</span>
          <div class="overSeasRadio">
            <el-radio v-model="overSeas" label="是" @focus="hideKey">是</el-radio>
            <el-radio v-model="overSeas" label="否" @focus="hideKey">否</el-radio>
          </div>
        </div>
        <div class="insurance">
          <van-field label="参保类型"
                     :value="insuranceType"
                     readonly is-link
                     @click="showInsuranceTypeSelector"/>
          <van-popup v-model="isShowInsuranceTypeSelector" position="bottom" :style="{ height: '40%' }">
            <van-picker
              title="参保类型"
              show-toolbar
              :columns="insuranceTypeOptions"
              @confirm="onConfirmInsuranceType"
              @cancel="onCancelInsuranceType"
            />
          </van-popup>

<!--          <span>参保类型</span>-->
<!--          <el-select v-model="insuranceType"-->
<!--                     @focus="hideKey"-->
<!--                     style="width: 70%;margin-right: 10px">-->
<!--            <el-option-->
<!--              v-for="(item,index) in insuranceTypeOptions"-->
<!--              :key="index"-->
<!--              :label="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </div>


        <div class="submit">
          <el-button type="primary"
                     :disabled="isClick"
                     @click="submit"
                     style="width: 70%;margin-top: 20px">
            提交</el-button>
        </div>

        <!--          身份证键盘  -->
<!--        <div class='key-container'>-->
<!--          <div class='keyboard' @click.stop='_handleKeyPress' v-if="isShow">-->
<!--            <div class="hide" data-num='H'>-->
<!--              <img data-num='H' src="../../assets/hide.png" alt=""-->
<!--                   style="width: 40px;height: 15px;">-->
<!--            </div>-->
<!--            <div class='key-row'>-->
<!--              <div class='key-cell' data-num='1'>1</div>-->
<!--              <div class='key-cell' data-num='2'>2</div>-->
<!--              <div class='key-cell' data-num='3'>3</div>-->
<!--            </div>-->
<!--            <div class='key-row'>-->
<!--              <div class='key-cell' data-num='4'>4</div>-->
<!--              <div class='key-cell' data-num='5'>5</div>-->
<!--              <div class='key-cell' data-num='6'>6</div>-->
<!--            </div>-->
<!--            <div class='key-row'>-->
<!--              <div class='key-cell' data-num='7'>7</div>-->
<!--              <div class='key-cell' data-num='8'>8</div>-->
<!--              <div class='key-cell' data-num='9'>9</div>-->
<!--            </div>-->
<!--            <div class='key-row'>-->
<!--              <div class='key-cell' data-num='X'>X</div>-->
<!--              <div class='key-cell' data-num='0'>0</div>-->
<!--              <div class='key-cell' data-num='D'>删除</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>

</template>

<script>
    import  storage from '../../model/storage.js'


    export default {
      name: "formIndex",
      // components: {IdCardInput},
      data() {
          return {
            countryOptions: [
              "中国",
              "中国香港",
              "中国澳门",
              "中国台湾",
              "韩国",
              "日本",
              "意大利",
              "西班牙",
              "法国",
              "德国",
              "美国",
              "加拿大",
              "新加坡",
              "马来西亚",
              "巴林",
              "阿联酋",
              "瑞士",
              "荷兰",
              "英国",
              "瑞典",
              "澳大利亚",
              "新西兰",
              "巴西",
              "阿根廷",
              "伊朗",
              "阿富汗",
              "阿尔巴尼亚",
              "南极洲",
              "阿尔及利亚",
              "美属萨摩亚",
              "安道尔",
              "安哥拉",
              "安提瓜和巴布达",
              "阿塞拜疆",
              "奥地利",
              "巴哈马",
              "孟加拉国",
              "亚美尼亚",
              "巴勒斯坦",
              "巴巴多斯",
              "比利时",
              "百慕大",
              "不丹",
              "玻利维亚",
              "波黑",
              "博茨瓦纳",
              "布维岛",
              "伯利兹",
              "英属印度洋领地",
              "所罗门群岛",
              "英属维尔京群岛",
              "文莱",
              "保加利亚",
              "缅甸",
              "布隆迪",
              "白俄罗斯",
              "柬埔寨",
              "喀麦隆",
              "佛得角",
              "开曼群岛",
              "中非",
              "斯里兰卡",
              "乍得",
              "智利",
              "圣诞岛",
              "科科斯（基林）群岛",
              "哥伦比亚",
              "科摩罗",
              "马约特",
              "刚果（布）",
              "刚果（金）",
              "库克群岛",
              "哥斯达黎加",
              "克罗地亚",
              "古巴",
              "塞浦路斯",
              "捷克",
              "贝宁",
              "丹麦",
              "多米尼克",
              "多米尼加",
              "厄瓜多尔",
              "萨尔瓦多",
              "赤道几内亚",
              "埃塞俄比亚",
              "厄立特里亚",
              "爱沙尼亚",
              "法罗群岛",
              "福克兰群岛（马尔维纳斯群岛）",
              "南乔治亚岛和南桑德韦奇岛",
              "斐济",
              "芬兰",
              "奥兰群岛",
              "法属圭亚那",
              "法属波利尼西亚",
              "法属南部领地",
              "吉布提",
              "加蓬",
              "格鲁吉亚",
              "冈比亚",
              "加纳",
              "直布罗陀",
              "基里巴斯",
              "希腊",
              "格陵兰",
              "格林纳达",
              "瓜德罗普",
              "关岛",
              "危地马拉",
              "几内亚",
              "圭亚那",
              "海地",
              "赫德岛和麦克唐纳岛",
              "梵蒂冈",
              "洪都拉斯",
              "匈牙利",
              "冰岛",
              "印度",
              "印度尼西亚",
              "伊拉克",
              "爱尔兰",
              "以色列",
              "科特迪瓦",
              "牙买加",
              "哈萨克斯坦",
              "约旦",
              "肯尼亚",
              "朝鲜",
              "科威特",
              "吉尔吉斯斯坦",
              "老挝",
              "黎巴嫩",
              "莱索托",
              "拉脱维亚",
              "利比里亚",
              "利比亚",
              "列支敦士登",
              "立陶宛",
              "卢森堡",
              "马达加斯加",
              "马拉维",
              "马尔代夫",
              "马里",
              "马耳他",
              "马提尼克",
              "毛里塔尼亚",
              "毛里求斯",
              "墨西哥",
              "摩纳哥",
              "蒙古",
              "摩尔多瓦",
              "黑山",
              "蒙特塞拉特",
              "摩洛哥",
              "莫桑比克",
              "阿曼",
              "纳米比亚",
              "瑙鲁",
              "尼泊尔",
              "荷属安的列斯",
              "阿鲁巴",
              "新喀里多尼亚",
              "瓦努阿图",
              "尼加拉瓜",
              "尼日尔",
              "尼日利亚",
              "纽埃",
              "诺福克岛",
              "挪威",
              "北马里亚纳",
              "美国本土外小岛屿",
              "密克罗尼西亚",
              "马绍尔群岛",
              "帕劳",
              "巴基斯坦",
              "巴拿马",
              "巴布亚新几内亚",
              "巴拉圭",
              "秘鲁",
              "菲律宾",
              "皮特凯恩群岛",
              "波兰",
              "葡萄牙",
              "几内亚比绍",
              "东帝汶",
              "波多黎各",
              "卡塔尔",
              "留尼汪",
              "罗马尼亚",
              "俄罗斯",
              "卢旺达",
              "圣赫勒拿",
              "圣基茨和尼维斯",
              "安圭拉",
              "圣卢西亚",
              "圣皮埃尔和密克隆",
              "圣文森特和格林纳丁斯",
              "圣马力诺",
              "圣多美和普林西比",
              "沙特阿拉伯",
              "塞内加尔",
              "塞尔维亚",
              "塞舌尔",
              "塞拉利昂",
              "斯洛伐克",
              "越南",
              "斯洛文尼亚",
              "索马里",
              "南非",
              "津巴布韦",
              "西撒哈拉",
              "苏丹",
              "苏里南",
              "斯瓦尔巴岛和扬马延岛",
              "斯威士兰",
              "叙利亚",
              "塔吉克斯坦",
              "泰国",
              "多哥",
              "托克劳",
              "汤加",
              "特立尼达和多巴哥",
              "突尼斯",
              "土耳其",
              "土库曼斯坦",
              "特克斯和凯科斯群岛",
              "图瓦卢",
              "乌干达",
              "乌克兰",
              "北马其顿",
              "埃及",
              "格恩西岛",
              "泽西岛",
              "英国属地曼岛",
              "坦桑尼亚",
              "美属维尔京群岛",
              "布基纳法索",
              "乌拉圭",
              "乌兹别克斯坦",
              "委内瑞拉",
              "瓦里斯和福图纳",
              "萨摩亚",
              "也门",
              "赞比亚"
            ],
            isShowCountrySelector: false,
            idCardTypeRadio: '居民身份证',
            idCardTypeOptions: [
              // '居民身份证',
              '护照',
              '港澳居民来往内地通行证（俗称回乡证）',
              '台湾居民来往内地通行证（俗称台胞证）',
              '出生医学证明',
              '其它'
            ],
            isShowIdCardTypeSelector: false,
            country: '中国',
            idCardType: '居民身份证',
            idCard: '',
            userName: '',
            sexRadio: '男',
            age: '',
            birthday: '',
            phone: '',
            remarks: '无',
            isClick: false,
            checkNotice: false,
            showModel: false,
            department: '',
            EnterpriseName: '深圳监狱',
            EnterpriseNameOptions: ['深圳监狱', '启新辉公司', '龙城物业公司', '中饰南方', '其它'],
            isShowEnterpriseNameSelector: false,
            otherEnterpriseName: '',
            EnterpriseNameReal: '',
            personType: '干警',
            personTypeOptions: ['干警','雇员','员工','外协','职工','派驻'],
            isShowPersonTypeSelector: false,
            Residence: '',
            personIdentity: '国内出行人员',
            personIdentityOptions: [
              '出入境通关人员',
              '国内出行人员',
              '上岗就业人员',
              '返校复课师生',
              '医疗机构工作人员',
              '口岸检疫和边防检查人员',
              '监所工作人员',
              '社会福利养老机构工作人员',
              '孕产妇',
              '新生儿',
              '母婴服务类机构人员',
              '农贸市场海水产品从业人员',
              '农贸市场禽畜肉类从业人员',
              '农贸市场进口食品类从业人员',
              '农贸市场其他人员',
              '农贸市场专项排查其他从业人员',
              '屠宰场/各类冷库从业人员',
              '农贸市场中地下或通风不良场所从业人员',
              '其它人群',
            ],
            isShowPersonIdentitySelector: false,
            personIdentityOptionsArray: {
              '出入境通关人员': 0,
              '国内出行人员': 1,
              '上岗就业人员': 2,
              '返校复课师生': 3,
              '医疗机构工作人员': 4,
              '口岸检疫和边防检查人员': 5,
              '监所工作人员': 6,
              '社会福利养老机构工作人员': 7,
              '孕产妇': 8,
              '新生儿': 9,
              '母婴服务类机构人员': 10,
              '农贸市场海水产品从业人员': 11,
              '农贸市场禽畜肉类从业人员': 12,
              '农贸市场进口食品类从业人员': 13,
              '农贸市场其他人员': 14,
              '农贸市场专项排查其他从业人员': 15,
              '屠宰场/各类冷库从业人员': 16,
              '农贸市场中地下或通风不良场所从业人员': 17,
              '其它人群': 18,
            },
            personIdentityIndex: 1,
            overSeas: '否',
            insuranceType: '本市',
            insuranceTypeOptions: [
              '本市',
              '省内异地',
              '非参保人',
              '省外',
              '无法核实'
            ],
            isShowInsuranceTypeSelector: false,
            isShow: false,
          }
        },
      created() {
          let userData = storage.get('prisonUserData')
          let on = this.$route.query.on
          if (on === 1 || on === '1') {
            return
          }
          if(userData && userData.length == 1) {
            this.$router.push({
              path: '/prison_code',
              query: {
                index: 0
              }
            })
          }else if(userData && userData.length > 1) {
            this.$router.push({
              path: '/prison_list'
            })
          }
        },
      watch: {
        // idCard(newval, val) {
        //   // console.log(val)
        //   console.log(newval)
        //   if(newval !== val) {
        //     let idCardType = this.idCardType
        //     // console.log(idCardType)
        //     if(newval.length >= 18 && idCardType == '居民身份证') {
        //       let idCard = newval.substr(0,18).toUpperCase()
        //       this.idCard = idCard
        //       if(idCardType == "居民身份证" && !this.id_card_mix(idCard)) {
        //         // this.$message.error('请核实身份证信息')
        //         console.log('请核实身份证信息')
        //         return;
        //       }
        //       const agesex = this.analyzeIDCard(newval);
        //       console.log(agesex)
        //       if (agesex.sex == '男') {
        //         this.sexRadio = '男'
        //       }else {
        //         this.sexRadio = '女'
        //       }
        //       this.age = agesex.age
        //       this.sexRadio = agesex.sex
        //       this.birthday = agesex.birthday
        //     }
        //   }
        // }
      },
      methods: {
        showInsuranceTypeSelector() {
          this.isShowInsuranceTypeSelector = true
        },
        onConfirmInsuranceType(e) {
          this.insuranceType = e
          this.isShowInsuranceTypeSelector = false
        },
        onCancelInsuranceType() {
          this.isShowInsuranceTypeSelector = false
        },
        showPersonIdentitySelector() {
          this.isShowPersonIdentitySelector = true
        },
        onConfirmPersonIdentity(e) {
          this.personIdentity = e
          this.personIdentityIndex = this.personIdentityOptionsArray[e]
          console.log(this.personIdentityIndex)
          this.isShowPersonIdentitySelector = false
        },
        onCancelPersonIdentity() {
          this.isShowPersonIdentitySelector = false
        },

        showCountrySelector() {
          this.isShowCountrySelector = true
        },
        onConfirmCountry(e) {
          this.country = e
          this.isShowCountrySelector = false
        },
        onCancelCountry() {
          this.isShowCountrySelector = false
        },

        showPersonTypeSelector() {
          this.isShowPersonTypeSelector = true
        },
        onConfirmPersonType(e) {
          this.personType = e
          this.isShowPersonTypeSelector = false
        },
        onCancelPersonType() {
          this.isShowPersonTypeSelector = false
        },
        showEnterpriseNameSelector() {
          this.isShowEnterpriseNameSelector = true
        },
        onConfirmEnterpriseName(e) {
          this.EnterpriseName = e
          this.isShowEnterpriseNameSelector = false
        },
        onCancelEnterpriseName() {
          this.isShowEnterpriseNameSelector = false
        },
        showIdCardTypeSelector() {
          this.isShowIdCardTypeSelector = true
        },
        onConfirmIdCardType(e) {
          this.idCardType = e
          this.isShowIdCardTypeSelector = false
        },
        onCancelIdCardType() {
          this.isShowIdCardTypeSelector = false
        },
          userNameFocus() {
            this.hideKey()
          },
          personIdentityChange(event) {
            console.log(event)
            this.personIdentityIndex = this.personIdentityOptionsArray[event]
          },
          EnterpriseNameChange(otherEnterpriseName) {
            this.EnterpriseNameReal = otherEnterpriseName
          },
          countryChange(country) {
            if(country === '中国') {
              this.idCardType = '居民身份证'
            }
            if(country !== '中国') {
              this.idCardType = '护照'
            }
          },
          idCardTypeChange(idCardType) {
            this.idCardType = idCardType
            if(idCardType  === '居民身份证') {
              this.idCardType = '居民身份证'
              this.country = '中国'
              this.idCardComputed()
            }
          },
          idCardComputed() {
          if(this.idCard.length >= 18 && this.idCardType === '居民身份证') {
            let idCard = this.idCard.substr(0,18).toUpperCase()
            this.idCard = idCard
            console.log(idCard)
            if(this.idCardType === "居民身份证" && !this.id_card_mix(idCard)) {
              // this.$message.error('请核实身份证信息')
              console.log('请核实身份证信息')
              return;
            }
            console.log('过了校验')

            const agesex = this.analyzeIDCard(this.idCard);
            console.log(agesex)
            if (agesex.sex === '男') {
              this.sexRadio = '男'
            }else {
              this.sexRadio = '女'
            }
            this.age = agesex.age
            this.sexRadio = agesex.sex
            this.birthday = agesex.birthday
          }
        },
          birthdayChange(birthday) {
            let yearBirth = birthday.substring(0, 4);
            let monthBirth = birthday.substring(5, 7);
            let dayBirth = birthday.substring(8, 10);
            // 获取当前年月日并计算年龄
            let myDate = new Date();
            let monthNow = myDate.getMonth() + 1;
            let dayNow = myDate.getDay();
            let age = myDate.getFullYear() - yearBirth;
            if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
              age--;
            }
            // 得到年龄
            this.age = age;
            console.log(this.age)
          },
          idCardChange(value) {
            console.log("idCardChange",value)
            let idCardType = this.idCardType
            // console.log(idCardType)
            if(value.length >= 18 && idCardType == '居民身份证') {
              let idCard = value.substr(0,18).toUpperCase()
              this.idCard = idCard
              if(idCardType == "居民身份证" && !this.id_card_mix(idCard)) {
                // this.$message.error('请核实身份证信息')
                console.log('请核实身份证信息')
                return;
              }
              const agesex = this.analyzeIDCard(value);
              console.log(agesex)
              if (agesex.sex == '男') {
                this.sexRadio = '男'
              }else {
                this.sexRadio = '女'
              }
              this.age = agesex.age
              this.sexRadio = agesex.sex
              this.birthday = agesex.birthday
            }
          },
          idCardChangeValue() {
            if(this.idCardType == "居民身份证" && !this.id_card_mix(this.idCard)) {
              this.$message.error('请核实身份证信息');
              return;
            }
          },
          showDialogBtn() {
            this.showModel = true
          },
          hideModal() {
            this.showModel = false
          },
          submit() {
            this.hideKey()
            this.isClick = true
            const userDataItem = {}
            userDataItem['userName'] = this.userName
            userDataItem['idCardType'] = this.idCardType
            userDataItem['idCard'] = this.idCard
            userDataItem['age'] = this.age
            userDataItem['phone'] = this.phone
            userDataItem['sexRadio'] = this.sexRadio
            userDataItem['department'] = this.department
            userDataItem['EnterpriseName'] = this.EnterpriseName !== '其它' ? this.EnterpriseName : this.EnterpriseNameReal
            userDataItem['personType'] = this.personType
            userDataItem['country'] = this.country
            userDataItem['Residence'] = this.Residence
            userDataItem['personIdentity'] = this.personIdentity
            userDataItem['personIdentityIndex'] = this.personIdentityIndex
            userDataItem['overSeas'] = this.overSeas
            userDataItem['insurance'] = this.insuranceType


            let _this = this
            if(this.msgCheck(userDataItem)) {
              this.$message.error({
                message: this.msgCheck(userDataItem),
                duration: 2000,
                onClose() {
                  _this.isClick = false
                }
              })

              return;
            }

            console.log(userDataItem)
            console.log(this.userData)


            //获取缓存数据
            let userData = storage.get('prisonUserData') ? storage.get('prisonUserData') : []
            userData.unshift(userDataItem)
            storage.set('prisonUserData',userData)

            userData = storage.get('prisonUserData') ? storage.get('prisonUserData') : []
            let index = 0


            if(userData && userData.length === 1) {
              this.$router.push({
                path: '/prison_code',
                name: 'prisonCodePage',
                query: {
                  index: index
                }
              });
            }
            if(userData && userData.length > 1) {
              this.$router.push({
                path: '/prison_list',
                name: 'prisonList',
              });
            }
          },
          id_card_mix(code){
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            var tip = "";
            var pass = true;
            var reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/;
            if (!code || !code.match(reg)) {
              tip = "身份证号格式错误";
              pass = false;
            }else if (!city[code.substr(0, 2)]) {
              tip = "地址编码错误";
              pass = false;
            }else {
              //18位身份证需要验证最后一位校验位
              if (code.length == 18) {
                code = code.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                  ai = code[i];
                  wi = factor[i];
                  sum += ai * wi;
                }
                var last = parity[sum % 11];
                if (parity[sum % 11] != code[17]) {
                  tip = "校验位错误";
                  pass = false;
                }
              }
            }

            if(pass) return true;
            return false;
          },
          analyzeIDCard(IDCard) {
            let sexAndAge = {};
            // 获取用户身份证号码
            let userCard = IDCard;
            // 如果身份证号码为 undefind 则返回空
            if (!userCard) {
              return sexAndAge;
            }
            // 获取性别
            if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
              sexAndAge.sex = '男'
            } else {
              sexAndAge.sex = '女'
            }
            // 获取出生年月日
            //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
            let yearBirth = userCard.substring(6, 10);
            let monthBirth = userCard.substring(10, 12);
            let dayBirth = userCard.substring(12, 14);
            let birthday = yearBirth + '-' + monthBirth + '-' + dayBirth
            // 获取当前年月日并计算年龄
            let myDate = new Date();
            let monthNow = myDate.getMonth() + 1;
            let dayNow = myDate.getDay();
            let age = myDate.getFullYear() - yearBirth;
            if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
              age--;
            }
            //得到出生日期
            sexAndAge.birthday = birthday;
            // 得到年龄
            sexAndAge.age = age;
            // 返回性别和年龄
            return sexAndAge;
          },
          msgCheck(data) {
            var role=/^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|30|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
            if(!data.userName) return '请输入姓名'
            if(!data.idCard) return '请输入证件号码'
            if(data.idCardType === "居民身份证"&&!this.id_card_mix(data.idCard)) return '身份证可能有误，请确认填写无误'
            if(!data.age) return '请输入年龄'
            if(!data.phone) return '请输入手机号'
            if(!data.sexRadio) return '请选择性别'
            if(!data.department) return '请输入监狱管理部门'
            if(!data.country) return '请选择国籍'
            if(!data.Residence) return '请输入居住地'
            if(!/^1[3456789]\d{9}$/.test(data.phone)) return '手机格式错误'
            return ;
          },



          //处理按键
          _handleKeyPress(e) {
            let num = e.target.dataset.num;

            //不同按键处理逻辑
            // -1 代表无效按键，直接返回
            if (num == -1) return false;

            switch (String(num)) {
              //小数点
              case '.':
                this._handleDecimalPoint();
                break;
              //删除键
              case 'D':
                this._handleDeleteKey();
                break;
              //删除键
              case 'H':
                this._handHide();
                break;
              //清空键
              case 'C':
                this._handleClearKey();
                break;
              //确认键
              case 'S':
                this._handleConfirmKey();
                break;
              default:
                this._handleNumberKey(num);
                break;
            }
          },
          //处理小数点函数
          _handleDecimalPoint() {
            //如果包含小数点，直接返回
            if (this.idCard.indexOf('.') > -1) return false;
            //如果小数点是第一位，补0
            if (!this.idCard.length)
              this.idCard = '0.';

            //如果不是，添加一个小数点
            else
              this.idCard = this.idCard + '.';

          },
          //处理删除键
          _handleDeleteKey() {
            let S = this.idCard;
            //如果没有输入，直接返回
            if (!S.length) return false;
            //否则删除最后一个
            this.idCard = S.substring(0, S.length - 1);

          },
          //处理清空键
          _handleClearKey() {
            this.idCard = '';
          },
          //处理数字
          _handleNumberKey(num) {
            let S = this.idCard;

            //如果有小数点且小数点位数不小于2
            if ( S.indexOf('.') > -1 && S.substring(S.indexOf('.') + 1).length < 2)
              this.idCard = S + num;


            //没有小数点
            if (!(S.indexOf('.') > -1)) {
              //如果第一位是0，只能输入小数点
              if (num == 0 && S.length == 0)
                this.idCard = '0.';

              else {
                if (S.length && Number(S.charAt(0)) === 0) return;
                this.idCard = S + num;
              }

            }

          },
          //提交
          _handleConfirmKey() {
            let S = this.idCard;
            //未输入
            if (!S.length){
              alert( '您目前未输入!' )
              return false;
            }

            //将 8. 这种转换成 8.00
            if (S.indexOf('.') > -1 && S.indexOf('.') == (S.length - 1))
              S = Number(S.substring(0, S.length - 1)).toFixed(2);
            //保留两位
            S = Number(S).toFixed(2);
            this.$emit('confirmEvent',S)
          },
          //隐藏键盘
          _handHide() {
            console.log('hide')
            this.isShow = false
          },
          // 显示键盘
          showKey() {
            let _this = this
            if (this.idCardType === '居民身份证') {
              this.isShow = true
              // console.log(event)
              // 隐藏聚焦自动弹出自带键盘
              // this.$refs.idCardInputBox.setAttribute('readonly', 'readonly');
              // let target = event.target
              // target.readOnly = false
              // setTimeout(() => {
              //   _this.$refs.idCardInputBox.removeAttribute('readonly');
              // }, 200)
            }

          },
          // 隐藏键盘
          hideKey() {
            this.isShow = false
          },

        }
    }
</script>

<style scoped>
  .formIndex{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow-y: auto;
  }
  .gap{
    width: auto;
    height: 15px;
    background-color: #edebeb;
  }
  .userName>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .idCardType>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .idCard>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .age>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .country>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .birthday>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .phone>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .department>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
    width: 200px;
    padding: 0;
  }
  .EnterpriseName>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
    background-color: #fff;
  }
  .personType>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .Residence>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .personIdentity>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .remarks>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .insurance>>>.el-input__inner {
    border: 0;
    font-size: 1.1rem;
    height: 40px;
  }
  .title {
    margin-top: 20px;
    padding-left: 10px
  }
  .title p {
    margin-top: -10px;
    font-size: 18px;
    color: #f0b27f;
  }
  .country,
  .idCardType,
  .idCard,
  .sex,
  .age,
  .userName,
  .birthday,
  .phone,
  .remarks,
  .notice,
  .department,
  .EnterpriseName,
  .Residence,
  .personIdentity,
  .overSeas,
  .insurance,
  .personType{
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid #f1f4f8;
  }
  .userName>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .idCard>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .idCard>>>input::-webkit-input-placeholder{
    font-size: 14px;
    color: #d1d4da;
  }

  .birthday>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .age>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .phone>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .personType>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .Residence>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .remarks>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .department>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }
  .EnterpriseName>>>.el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
  }


  .idCardType>>>.van-field__label{
    font-size: 1.1rem;
    color: #000;
    width: auto;
  }
  .idCardType>>>.van-cell__value{
    width: 70%;
  }
  .idCardType>>>.van-field__body{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .idCardType>>>.van-field__control{
    font-size: 1.1rem;
    text-align: left;
    width: 90%;
  }
  .EnterpriseName>>>.van-field__label{
    font-size: 1.1rem;
    color: #000;
    width: auto;
  }
  .EnterpriseName>>>.van-cell__value{
    width: 70%;
  }
  .EnterpriseName>>>.van-field__body{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .EnterpriseName>>>.van-field__control{
    font-size: 1.1rem;
    text-align: left;
    width: 90%;
  }
  .personType>>>.van-field__label{
    font-size: 1.1rem;
    color: #000;
    width: auto;
  }
  .personType>>>.van-cell__value{
    width: 70%;
  }
  .personType>>>.van-field__body{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .personType>>>.van-field__control{
    font-size: 1.1rem;
    text-align: left;
    width: 90%;
  }

  .country>>>.van-field__label{
    font-size: 1.1rem;
    color: #000;
    width: 70px;
  }
  .country>>>.van-cell__value{
    width: 70%;
  }
  .country>>>.van-field__body{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .country>>>.van-field__control{
    font-size: 1.1rem;
    text-align: left;
    width: 90%;
  }
  .personIdentity>>>.van-field__label{
    font-size: 1.1rem;
    color: #000;
    width: auto;
  }
  .personIdentity>>>.van-cell__value{
    width: 70%;
  }
  .personIdentity>>>.van-field__body{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .personIdentity>>>.van-field__control{
    font-size: 1.1rem;
    text-align: left;
    width: 90%;
  }
  .insurance>>>.van-field__label{
    font-size: 1.1rem;
    color: #000;
    width: auto;
  }
  .insurance>>>.van-cell__value{
    width: 70%;
  }
  .insurance>>>.van-field__body{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .insurance>>>.van-field__control{
    font-size: 1.1rem;
    text-align: left;
    width: 90%;
  }


  span{
    font-size: 1.1rem;
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    display: flex;
    white-space: nowrap;
  }
  .userName{
    margin-top: 15px;
  }
  .sexRadio,.idCardTypeRadio{
    flex: 10;
    display: flex;
    align-items: center;
    height: 40px;
  }
  .overSeasRadio{
    display: flex;
    flex: 3.5;
    align-items: center;
    height: 40px;
  }

  .overSeasRadio>>>.el-radio__label{
    font-size: 1.1rem;
  }
  .sexRadio>>>.el-radio__label{
    font-size: 1.1rem;
  }
  .submit{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }



  .key-container {
    margin-top: 50px;
    width: 100%;
    display: flex;
    display : -webkit-flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .input-box {
    font-size: 35px;
    font-weight: bold;
    height: 40px;
    border-bottom: 1px solid #aaa;
    padding: 10px 15px;
    text-align: right;
    width: 90%;

  }

  .keyboard {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 265px;
    width: 100%;
    background-color: #fff;
    z-index: 9999;

  }
  .hide {
    height: 25px;
    line-height: 25px;
    text-align: center;
    /*background-color: #e6e5e5;*/
    background: linear-gradient(#e6e5e5, #f4f4f4);
  }
  .key-cell:active{
    background-color: #cbcdd1;
  }
  .keyboard .key-row {
    display: flex;
    display: -webkit-flex;
    position: relative;
    height: 60px;
    line-height: 60px;
  }

  .keyboard .key-row::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #d5d5d6;
    color: #d5d5d6;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .keyboard .key-cell {
    flex: 1;
    -webkit-box-flex: 1;
    text-align: center;
    position: relative;
  }

  .keyboard .key-cell::after {
    content: '';
    position: absolute;
    overflow: hidden;
    top: 0;
    right: 0;
    bottom: 0;
    height: 200%;
    border-right: 1px solid #d5d5d6;
    color: #d5d5d6;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .keyboard .key-cell:nth-last-child(1)::after {
    border-right: 0;
  }

  .keyboard .disabled {
    background: rgba(0, 0, 0, 0.2);
  }

  .keyboard .key-confirm {
    position: absolute;
    text-align: center;
    height: 118px;
    width: 25%;
    line-height: 118px;
    background: #fff;
    z-index: 5;
    right: 0;
    bottom: 1px;
  }

</style>



// WEBPACK FOOTER //
// src/views/prison/prisonFormIndex.vue